import React from 'react';
import { Table, Badge, Button } from 'reactstrap';
import AddressHelper from '@components/Elements/AddressHelper/AddressHelper';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SortableTh from '@components/SortableTh/SortableTh';

export default props => {
  return (
    <Table hover={true}>
      <thead>
        <tr>
          <SortableTh
            {...props}
            label={'Issue Date'}
            field={'EvidenceOfInsurances.issue_date'}
          />
          <th>Homeowners</th>
          <th>Mortgages & Escrow</th>
          <th>Borrower Contact</th>
          <th>Status</th>
          <th>Options</th>
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          const issueDate = moment(item.issue_date * 1000).format('MM/DD/YYYY');
          console.log(item);
          return (
            <tr
              className={'pointer'}
              key={'eoi-' + item.id}
              onClick={event => {
                if (event.target.nodeName !== 'BUTTON') {
                  props.onEntityClick(item.id);
                }
              }}
            >
              <td className={'text-nowrap'}>{issueDate}</td>
              <td>
                {item.owner !== null && (
                  <div className={'pb-2'}>
                    {item.owner}{' '}
                    {item.second_owner.length > 0 && (
                      <span>and {item.second_owner}</span>
                    )}
                    <br />
                    {item.vesting_1}
                  </div>
                )}
                {item.third_owner !== null && item.third_owner.length > 0 && (
                  <div>
                    {item.third_owner}{' '}
                    {item.fourth_owner.length > 0 && (
                      <span>and {item.fourth_owner}</span>
                    )}
                    <br />
                    {item.vesting_2}
                  </div>
                )}
              </td>
              <td>
                {item.escrow_number !== null && item.escrow_number.length > 0 && (
                  <div>
                    <strong>Escrow #:</strong> {item.escrow_number}
                  </div>
                )}
                {item.mortgage_id_1 !== null && (
                  <React.Fragment>
                    <strong>1st Loan #:</strong> {item.loan_number_1}
                    <br />
                    <strong>1st Lender:</strong> {item.first_mortgage.name}
                  </React.Fragment>
                )}
                {item.mortgage_id_2 !== null && (
                  <React.Fragment>
                    <br />
                    <strong>2nd Loan #:</strong> {item.loan_number_2}
                    <br />
                    <strong>2nd Lender:</strong> {item.second_mortgage.name}
                  </React.Fragment>
                )}
                {item.mortgage_id_3 !== null && (
                  <React.Fragment>
                    <br />
                    <strong>3rd Loan #:</strong> {item.loan_number_3}
                    <br />
                    <strong>3rd Lender:</strong> {item.third_mortgage.name}
                  </React.Fragment>
                )}
                {item.is_additional_insured === 1 && (
                  <div>
                    <FontAwesomeIcon icon={['far', 'check-square']} />
                    &nbsp;&nbsp;Additional Insured
                  </div>
                )}
                {item.is_lenders_loss_payable === 1 && (
                  <div>
                    <FontAwesomeIcon icon={['far', 'check-square']} />
                    &nbsp;&nbsp;Lender's Loss Payble
                  </div>
                )}
                {item.is_loss_payee === 1 && (
                  <div>
                    <FontAwesomeIcon icon={['far', 'check-square']} />
                    &nbsp;&nbsp;Loss Payee
                  </div>
                )}
                {item.is_mortgagee === 1 && (
                  <div>
                    <FontAwesomeIcon icon={['far', 'check-square']} />
                    &nbsp;&nbsp;Mortgagee
                  </div>
                )}
              </td>
              <td>
                {item.mailing_email !== null && (
                  <React.Fragment>
                    {item.mailing_email}
                    <br />
                  </React.Fragment>
                )}
                {item.mailing_phone !== null && (
                  <React.Fragment>
                    {item.mailing_phone}
                    <br />
                  </React.Fragment>
                )}
                {item.mailing_address_line_1 !== null &&
                  item.mailing_address_line_1.length > 0 && (
                    <React.Fragment>
                      {item.mailing_address_line_1}
                      <br />
                    </React.Fragment>
                  )}
                {item.mailing_address_line_2 !== null &&
                  item.mailing_address_line_2.length > 0 && (
                    <React.Fragment>
                      {item.mailing_address_line_2}
                      <br />
                    </React.Fragment>
                  )}
                <AddressHelper
                  city={item.mailing_city}
                  state={item.mailing_state}
                  zip_code={item.mailing_zip_code}
                  address_line_1={null}
                  address_line_2={null}
                />
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>
                {item.status === 0 ? (
                  <React.Fragment>
                    {item.scheduled_email !== null ? 'Scheduled' : 'Draft'}
                  </React.Fragment>
                ) : (
                  'Sent'
                )}
                <br />
                {item.pre_pay === 1 && item.qb_invoice_paid === 0 && (
                  <Badge color={'danger'}>PRE-PAY</Badge>
                )}
                {item.pre_pay === 1 &&
                  item.qb_invoice_paid === 1 &&
                  item.status === 0 && (
                    <Badge color={'success'}>PRE-PAID</Badge>
                  )}
              </td>
              <td>
                <Button
                  color={'link'}
                  size={'sm'}
                  className={'p-0 text-left'}
                  onClick={() => props.onCreateClick(item.id)}
                >
                  New EOI for the same homeowner
                </Button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
